/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAlipay = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M18.863 2H5.137A3.134 3.134 0 0 0 2 5.137v13.726A3.134 3.134 0 0 0 5.137 22h13.726A3.142 3.142 0 0 0 22 18.893c-2.052-1.144-4.937-2.694-7.66-3.948-1.432 1.963-3.757 3.616-6.636 3.616-3.15 0-4.184-2.023-4.332-3.41-.177-1.741.665-3.638 4.443-3.638 1.58 0 3.543.458 5.676 1.114a17.943 17.943 0 0 0 1.18-2.694H6.716v-.745h4.11V7.793H5.942v-.848h4.886V4.694H13.1v2.25h4.886v.85H13.1v1.394h3.963s-.68 2.081-1.713 4.059c2.185.745 4.465 1.609 6.635 2.354V5.137A3.126 3.126 0 0 0 18.863 2zM4.111 14.989c.044.9.457 2.398 3.122 2.398 2.324 0 4.133-1.77 5.262-3.254-1.993-.834-3.772-1.402-4.886-1.402-3.011 0-3.542 1.476-3.498 2.258z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAlipay as Alipay };
